import { assetUrl } from '../../helper_functions/utilities';

const APEX_TIERS = new Set(['CHALLENGER', 'GRANDMASTER', 'MASTER']);
const TIER_ICON_MAP = {
    CHALLENGER: 'Rank=Challenger',
    GRANDMASTER: 'Rank=Grandmaster',
    MASTER: 'Rank=Master',
    DIAMOND: 'Rank=Diamond',
    EMERALD: 'Rank=Emerald',
    PLATINUM: 'Rank=Platinum',
    GOLD: 'Rank=Gold',
    SILVER: 'Rank=Silver',
    BRONZE: 'Rank=Bronze',
    IRON: 'Rank=Iron',
};
const SEARCH_ROLE_ICON_MAP = {
    TOP: 'position-top-light.svg',
    JUNGLE: 'position-jungle-light.svg',
    MID: 'position-middle-light.svg',
    MIDDLE: 'position-middle-light.svg',
    ADC: 'position-bottom-light.svg',
    BOTTOM: 'position-bottom-light.svg',
    SUPPORT: 'position-utility-light.svg',
    UTILITY: 'position-utility-light.svg',
};

export function buildSearchProfileIconSrc(profileIconId) {
    return assetUrl(`/profile_icons/${profileIconId}.png`);
}

export function buildSearchChampionIconSrc(championNameId) {
    return assetUrl(`/champion_icons/${championNameId}.png`);
}

export function buildSearchTierIconSrc(tier) {
    const iconName = TIER_ICON_MAP[tier] || 'Rank=Unranked';
    return `${process.env.PUBLIC_URL}/assets/ranked_icons/${iconName}.png`;
}

export function buildSearchRoleIconSrc(roleLabel) {
    const iconName = SEARCH_ROLE_ICON_MAP[String(roleLabel || '').trim().toUpperCase()];
    if (!iconName) {
        return '';
    }

    return `${process.env.PUBLIC_URL}/assets/role_icons/${iconName}`;
}

export function formatSearchEloLabel(competitive) {
    if (!competitive?.tier || competitive.tier === 'UNRANKED') {
        return 'Unranked';
    }

    if (APEX_TIERS.has(competitive.tier)) {
        return competitive.tier;
    }

    return `${competitive.tier} ${competitive.division || ''}`.trim();
}

export function formatSearchQueueLabel(queue) {
    if (!queue) {
        return '';
    }

    if (queue === 'flex') {
        return 'Flex';
    }

    return 'Solo/Duo';
}

export function formatSearchMasteryPoints(points) {
    return `${Intl.NumberFormat().format(points || 0)}`;
}
